import React from 'react'
import { PageWrapper, PageContainerMain } from '../pages.styled'
import { useSelector } from 'react-redux' 

export default function Marketplace() {
    
    const { user } = useSelector((state) => state.auth) 
    return (
        <PageWrapper> 
        </PageWrapper>
    )
}
